import {Component, EventEmitter, OnInit, Output, inject} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule} from '@angular/forms';
import {StandardSubjectFormComponent} from '../standard-subject-form.component';
import {dateValidator} from '../../../../_utils/validators';
import {FOUR_DIGITS_PATTERN} from '../../../../_constants/constants';
import {NgClass} from '@angular/common';
import {HideOnBlurDirective} from '../../../../_directives/hide-on-blur.directive';
import {NgxMaskModule} from 'ngx-mask';
import {ValidationErrorsComponent as ValidationErrorsComponent_1} from '../../../../common/forms/validation-errors/validation-errors.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-bvs-subject-form',
    templateUrl: './bvs-subject-form.component.html',
    styleUrls: ['./bvs-subject-form.component.scss'],
    imports: [StandardSubjectFormComponent, ReactiveFormsModule, NgClass, HideOnBlurDirective, NgxMaskModule, ValidationErrorsComponent_1, TranslateModule]
})
export class BvsSubjectFormComponent implements OnInit {

  @Output() submittedData: EventEmitter<UntypedFormGroup> = new EventEmitter<UntypedFormGroup>();
  @Output() back: EventEmitter<void> = new EventEmitter<void>();

  subjectFormGroup: UntypedFormGroup;
  identificationFormGroup: UntypedFormGroup;
  addressFormGroup: UntypedFormGroup;

  /**
   * This gets passed to the nested validation-error components.
   *
   * @see {@link ValidationErrorsComponent.displayErrors}
   */
  displayErrors: boolean;

  private formBuilder = inject(UntypedFormBuilder);

  constructor() {
    const formBuilder = this.formBuilder;

    this.subjectFormGroup = StandardSubjectFormComponent.buildSubjectFormGroup(formBuilder);
    this.addressFormGroup = StandardSubjectFormComponent.buildAddressFormGroup(formBuilder);
    this.identificationFormGroup = this.formBuilder.group({
      sin: ['', Validators.pattern(FOUR_DIGITS_PATTERN)], //For BVSS (note: extra S)
      dob: ['', dateValidator]
    });
  }

  ngOnInit(): void {
  }

}
